'use client';

import { ArrowRight } from 'lucide-react';
import { motion } from 'motion/react';
import { routes } from '@workspace/routes';
import { Button } from '@workspace/ui/components/customButton';

import { trackCta } from '~/lib/track-cta';

export default function FinalCTA() {
  return (
    <section className="relative w-full overflow-hidden cta-gradient">
      <div className="absolute inset-0 bg-linear-to-b from-white/5 to-transparent dark:from-white/[0.03] pointer-events-none" />
      <div className="absolute inset-0 bg-linear-to-tr from-transparent via-white/3 to-white/10 dark:via-white/2 dark:to-white/5 pointer-events-none" />

      {/* Main content */}
      <div className="relative mx-auto max-w-4xl px-6 py-14 sm:py-20 md:py-24 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-foreground tracking-tight leading-[1.1] mb-4 sm:mb-5"
        >
          Ready to Create
          <br />
          Amazing AI Voiceover Videos?
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15, duration: 0.5 }}
          className="text-sm sm:text-base md:text-lg text-foreground/60 mb-8 sm:mb-10 max-w-2xl mx-auto leading-relaxed"
        >
          Transform your screen recordings into professional videos with
          AI-powered voiceovers in just minutes.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <Button
            size="lg"
            href={routes.dashboard.auth.SignUp}
            onClick={() => trackCta('cta_signup_clicked', { surface: 'homepage_final_cta' })}
            className="group text-base font-semibold gap-2.5 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300"
          >
            Start Free Trial
            <ArrowRight className="h-4 w-4 sm:h-5 sm:w-5" />
          </Button>
        </motion.div>
      </div>
    </section>
  );
}
